export const companyInfo = {
  name: "here.",
  tagline: "VENDING MACHINES",
  description: "Premium vape and nicotine vending solutions for bars, clubs, and festivals across Costa del Sol.",
  phone: "+34 66 000 7010",
  email: "info@herevending.io",
  logo: {
    dark: "https://customer-assets.emergentagent.com/job_f5c48eb0-33e1-4c2f-8646-482cac926822/artifacts/3tb0ojsw_image.png"
  }
};

export const howItWorks = [
  {
    id: 1,
    title: "Always Available",
    description: "Guests can purchase essentials whenever your venue is open, without relying on staff availability.",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Age Verification",
    description: "Built-in ID verification helps ensure compliance when purchasing age-restricted products.",
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "Cashless Payments",
    description: "Fast, secure card and contactless payments. No cash handling or staff involvement required.",
    icon: "CreditCard"
  },
  {
    id: 4,
    title: "Fully Managed Service",
    description: "We handle stocking, maintenance, and customer support. Zero hassle for venue owners.",
    icon: "Wrench"
  },
  {
    id: 5,
    title: "Additional Revenue",
    description: "Earn passive income from every sale with no investment or operational effort.",
    icon: "TrendingUp"
  },
  {
    id: 6,
    title: "Premium Design",
    description: "Sleek, modern machines that fit seamlessly into any venue aesthetic.",
    icon: "Box"
  }
];

export const products = [
  {
    id: 1,
    name: "Muss Marmol 700",
    category: "Disposable Vapes",
    description: "Premium disposable vapes with 700 puffs. Available in multiple refreshing flavors.",
    image: "https://images.unsplash.com/photo-1560924707-87c8c0e2c8c4?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Nicotine Pouches",
    category: "Tobacco-Free",
    description: "Smoke-free, spit-free nicotine pouches. Discreet and convenient for any occasion.",
    image: "https://images.unsplash.com/photo-1527661591475-527312dd65f5?w=400&h=400&fit=crop"
  }
];

export const locations = [
  {
    id: 1,
    city: "Marbella",
    description: "Puerto Banús & Golden Mile",
    active: true
  },
  {
    id: 2,
    city: "Fuengirola",
    description: "Beach clubs & nightlife district",
    active: true
  },
  {
    id: 3,
    city: "Málaga",
    description: "Centro histórico & Muelle Uno",
    active: true
  },
  {
    id: 4,
    city: "Torremolinos",
    description: "La Carihuela & La Nogalera",
    active: true
  },
  {
    id: 5,
    city: "Estepona",
    description: "Puerto deportivo & old town",
    active: false
  },
  {
    id: 6,
    city: "Benalmádena",
    description: "Puerto Marina & Bil Bil",
    active: false
  }
];

export const faqs = [
  {
    id: 1,
    question: "How does the partnership work?",
    answer: "We install and maintain the vending machine at your venue completely free. You earn a percentage of every sale, paid monthly. No upfront costs or hidden fees."
  },
  {
    id: 2,
    question: "What products are available in the machines?",
    answer: "Our machines offer a curated selection of premium nightlife essentials including disposable vapes, nicotine pouches, mints, condoms, and other venue-tailored products. Product selection can be customized based on your clientele and venue type."
  },
  {
    id: 3,
    question: "How is age verification handled?",
    answer: "Our machines feature integrated ID scanning technology that verifies customer age before purchase. This ensures full compliance with Spanish tobacco and nicotine regulations."
  },
  {
    id: 4,
    question: "Who handles restocking and maintenance?",
    answer: "Our team handles everything. We monitor inventory remotely and restock before products run out. Any technical issues are resolved within 24 hours."
  },
  {
    id: 5,
    question: "What venues are eligible for a machine?",
    answer: "Bars, nightclubs, beach clubs, restaurants, and festival venues in Costa del Sol are all eligible. We assess foot traffic and venue type to ensure mutual success."
  },
  {
    id: 6,
    question: "Is there a minimum contract period?",
    answer: "No long-term commitment is required. We offer flexible agreements and can start with a trial period to make sure the machine is a good fit for your venue. If it doesn’t work for either side, we remove it at no cost."
  }
];
